import { render, staticRenderFns } from "./TenderTabGeneralInformation.vue?vue&type=template&id=c15db9a8&"
import script from "./TenderTabGeneralInformation.vue?vue&type=script&lang=js&"
export * from "./TenderTabGeneralInformation.vue?vue&type=script&lang=js&"
import style0 from "./TenderTabGeneralInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports